import React from 'react';
import Fade from 'react-reveal/Fade';
import {useAppState, MarkupRender, getBackgroundImg, getUploadedImagePath, getPublicImagePath} from "@nutastic/nutastic-react-app";
import PageHeader from "../PageHeader";
import {DiscussionEmbed} from "disqus-react";
import getBackgroundColor from "../../utils/getBackgroundColor";
import classnames from 'classnames';
import {Swiper, SwiperSlide} from 'swiper/swiper-react.cjs';
import SwiperCore, {Navigation, EffectFade, Autoplay} from 'swiper';
import Zoom from 'react-medium-image-zoom';

SwiperCore.use([Navigation, Autoplay, EffectFade]);

const ArticlePage = () => {
    const componentClass = 'blog-page';
    const {
        id,
        image,
        excerpt,
        title,
        date ,
        content: s1Content,
        num_1: s2Layout,
        field_1: s2Content,
        image_1: s2Image,
        num_2: s3Layout,
        field_2: s3Content,
        num_3: s4Layout,
        field_3: s4Content,
        image_2: s4Image,
        num_4: s5Layout,
        field_4: s5Content,
        num_5: s6Layout,
        field_5: s6Content,
        image_3: s6Image,
        field_10: lastSectionContent,
        slideshow1,
        slideshow2,
        slideshow3
    } = useAppState();

    const swiperProps = {
        autoplay: { delay: 7000 },
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true }
    };

    const renderSlideshowImages = slides => {
        return <Swiper className="article-slideshow" { ...swiperProps }>
            {
                slides.map((slide, i) => <SwiperSlide key={i}><Zoom>
                    <div className="slideshow-img" style={ getBackgroundImg(getUploadedImagePath(slide.image)) } />
                    <img className="zoom-img" src={ getUploadedImagePath(slide.image) } alt={ slide.name } />
                </Zoom></SwiperSlide>)
            }
        </Swiper>;
    };

    const renderContentSection = (sectionContent, colorId) => {
        const bgColorClass = getBackgroundColor(colorId);
        return sectionContent && parseInt(colorId) > 0 ? <section className={`page-section ${bgColorClass} page-section--padded`}>
            <div className="container text-left">
                <div className="paragraph"><MarkupRender content={sectionContent} /></div>
            </div>
        </section> : null
    };

    const renderImageSection = (content, image, layoutId, slides) => {
        const layoutKey = parseInt(layoutId);
        const sectionClasses = classnames('page-section', 'imgSection', 'background-white', {
            'imgSection--leftImage': layoutKey === 1 || layoutKey === 5,
            'imgSection--rightImage': layoutKey === 2 || layoutKey === 6,
            'imgSection--centerImage': layoutKey === 7 || layoutKey === 8,
            'imgSection--fullImage' : layoutKey === 3,
            'imgSection--bigWords' : layoutKey === 4
        });
        const useImageRender = layoutKey < 4 || layoutKey === 7;
        const useSlideshowRender = layoutKey > 4 && layoutKey !== 7;
        return layoutKey > 0 && layoutKey < 9 ? <section className={sectionClasses}>
            { useImageRender &&
                <Fade><Zoom>
                    <div className="imgSection__img" style={getBackgroundImg(getUploadedImagePath(image))} />
                    <img className="zoom-img" src={ getUploadedImagePath(image) } alt={ title } />
                </Zoom></Fade>
            }
            { useSlideshowRender && <div className="imgSection__img">{ renderSlideshowImages(slides) }</div> }
            <div className="imgSection__text">
                <div className="container">
                    {content}
                </div>
            </div>
        </section> : null
    };


    return <React.Fragment>
        <PageHeader image={image} title={title} subtext={excerpt} type={3} date={date} />
        { renderContentSection(s1Content, 6) }
        { renderImageSection(s2Content, s2Image, s2Layout, slideshow1) }
        { renderContentSection(s3Content, s3Layout) }
        { renderImageSection(s4Content, s4Image, s4Layout, slideshow2) }
        { renderContentSection(s5Content, s5Layout) }
        { renderImageSection(s6Content, s6Image, s6Layout, slideshow3) }
        { renderContentSection(lastSectionContent, 6) }
        <div className={`${componentClass}__disqusComments page-section page-section--padded background-light`}>
            <div className="container">
                <div className="text-center">
                    <a href="/blog" className={`btn btn-secondary ${componentClass}__back-btn`}>Back to Blog Articles</a>
                </div>
                <DiscussionEmbed
                    shortname='laronda-james-blog'
                    config={{
                        url: window.location.origin + window.location.pathname,
                        identifier: id
                    }}
                />
            </div>
        </div>
    </React.Fragment>
};

export default ArticlePage;
